module.exports = __webpack_public_path__ + "img/sgp_cicest.084ba91e.jpg";